import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import LoginImage from '../../../assets/images/login.jpg'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import classNames from 'classnames'
import http from '../../../config/BaseUrl'
import { useHistory, useParams } from 'react-router-dom'
const ResetPassword = () => {

  const history = useHistory();
  const { token } = useParams();
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit, watch, formState: { errors } } = useForm({ mode: 'all', reValidateMode: "onChange" })
  const password = useRef({});
  password.current = watch("password", "");
  const handelForgotPassword = async (data) => {
    try {
      setLoading(true)
      await http.post('reset', { ...data, token }).then((res) => {
        if (res.data.message) {
          history.push('/')
          setLoading(false)
        }
      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }
  return (
    <>
      <div className="section-authentication-login p-md-0 p-3">
        <div className="container-fluid px-0">

          <div className="row h-100">
            <div className="col-md-6 d-none d-md-block">
              <div className="page-image">
                <div className="login-header mt-5">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>

                </div>
                <div className="image-body">
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-body">
                <div className="row justify-content-center align-items-center h-100">
                  <div className="col-md-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="mb-4 font-weight-bold">Reset Password</h3>
                        </div>

                        <form onSubmit={handleSubmit(handelForgotPassword)}>
                          <div className="form-group">
                            <label htmFor="forgotEmail">Password </label>
                            <input
                              type="password"
                              name="password"
                              placeholder="Enter your password"
                              className={classNames("form-control", { "is-invalid": errors.password })}
                              {...register("password", {
                                required: "This field is required",
                                minLength: 6
                              })}
                            />
                            <span className="text-danger text-danger font-size-14">{errors.password && errors.password.message}</span>
                          </div>
                          <div className="form-group">
                            <label htmFor="forgotEmail">Password Confirm</label>
                            <input
                              type="password"
                              name="password_confirmation"
                              placeholder="Re-type your Password"
                              className={classNames("form-control", { "is-invalid": errors.password_confirm })}
                              {...register("password_confirm", {
                                validate: value =>
                                  value === password.current || "The passwords do not match"
                              })}
                            />
                          </div>

                          <div className="mt-3 btn-group w-100">
                            <button type="submit" className="btn btn-primary btn-block">
                              {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                : ("Reset Password")
                              }
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </>
  )
}

export default ResetPassword
